// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 可灵对口型节点样式 */

/* 节点容器 */
.KlingLipSyncNode-container {
  position: relative;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  min-width: 320px;
}

.KlingLipSyncNode-container:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border-color: #ec4899;
}

/* 标题 */
.KlingLipSyncNode-title {
  padding: 12px 16px;
  background: linear-gradient(135deg, #ec4899 0%, #db2777 100%);
  color: white;
  font-weight: 600;
  font-size: 14px;
  border-radius: 10px 10px 0 0;
  text-align: center;
  user-select: none;
}

/* 内容包装器 */
.KlingLipSyncNode-wrapper {
  padding: 16px;
  width: 320px;
}

/* Handle 样式 */
.KlingLipSyncNode-handle {
  width: 14px;
  height: 14px;
  border: 2px solid #ec4899;
  background: white;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.KlingLipSyncNode-handle:hover {
  width: 18px;
  height: 18px;
  border-width: 3px;
}

.KlingLipSyncNode-handle-video {
  border-color: #8b5cf6;
  background: #8b5cf6;
}

.KlingLipSyncNode-handle-audio {
  border-color: #f59e0b;
  background: #f59e0b;
}

.KlingLipSyncNode-handle-text {
  border-color: #667eea;
  background: #667eea;
}

.KlingLipSyncNode-handle-output {
  border-color: #ec4899;
  background: #ec4899;
}

/* Handle 标签 */
.KlingLipSyncNode-handle-label {
  position: absolute;
  left: -70px;
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(135deg, #ec4899 0%, #db2777 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(236, 72, 153, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.025em;
  z-index: 100;
}

.KlingLipSyncNode-handle:hover .KlingLipSyncNode-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(236, 72, 153, 0.35);
}

.KlingLipSyncNode-handle:hover .KlingLipSyncNode-handle-label::before {
  content: '';
  position: absolute;
  right: -4px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid #ec4899;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  filter: drop-shadow(0 1px 2px rgba(236, 72, 153, 0.2));
}

.KlingLipSyncNode-handle-video .KlingLipSyncNode-handle-label {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);
}

.KlingLipSyncNode-handle-video:hover .KlingLipSyncNode-handle-label {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

.KlingLipSyncNode-handle-video:hover .KlingLipSyncNode-handle-label::before {
  border-left-color: #667eea;
  filter: drop-shadow(0 1px 2px rgba(102, 126, 234, 0.2));
}

/* 节点被选中时，一直显示标签 */
.react-flow__node.selected .KlingLipSyncNode-handle .KlingLipSyncNode-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(236, 72, 153, 0.35);
}

.react-flow__node.selected .KlingLipSyncNode-handle-video .KlingLipSyncNode-handle-label {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

/* 标签出现动画 */
@keyframes KlingLipSyncNode-labelFadeIn {
  0% {
    opacity: 0;
    transform: translateY(-50%) translateX(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(-50%) translateX(-2px);
  }
}

.KlingLipSyncNode-handle:hover .KlingLipSyncNode-handle-label,
.react-flow__node.selected .KlingLipSyncNode-handle .KlingLipSyncNode-handle-label {
  animation: KlingLipSyncNode-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 可点击的 Handle 标签 */
.KlingLipSyncNode-handle-label-clickable {
  pointer-events: auto;  /* 改为可交互 */
  cursor: pointer;       /* 显示手型光标 */
  user-select: none;     /* 禁止文本选择 */
}

/* 可点击标签的悬停效果 */
.KlingLipSyncNode-handle-label-clickable:hover {
  transform: translateY(-50%) translateX(-4px) scale(1.05);
  box-shadow: 0 8px 24px rgba(236, 72, 153, 0.45);
}

.KlingLipSyncNode-handle-video .KlingLipSyncNode-handle-label-clickable:hover {
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.45);
}

.KlingLipSyncNode-handle-audio .KlingLipSyncNode-handle-label-clickable:hover {
  box-shadow: 0 8px 24px rgba(236, 72, 153, 0.45);
}

/* 可点击标签的按下效果 */
.KlingLipSyncNode-handle-label-clickable:active {
  transform: translateY(-50%) translateX(-2px) scale(0.98);
}

/* 添加点击提示图标 */
.KlingLipSyncNode-handle-label-clickable::after {
  content: ' +';
  font-weight: 700;
  margin-left: 4px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.KlingLipSyncNode-handle-label-clickable:hover::after {
  opacity: 1;
}

/* 字段容器 */
.KlingLipSyncNode-field {
  margin-bottom: 16px;
}

/* 标签 */
.KlingLipSyncNode-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.KlingLipSyncNode-optional {
  font-weight: 400;
  color: #9ca3af;
  font-size: 11px;
}

/* 按钮组 */
.KlingLipSyncNode-button-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.KlingLipSyncNode-button {
  padding: 10px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  background: white;
  color: #6b7280;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.KlingLipSyncNode-button:hover:not(:disabled) {
  border-color: #ec4899;
  color: #ec4899;
  background: #fdf2f8;
}

.KlingLipSyncNode-button-active {
  border-color: #ec4899;
  background: linear-gradient(135deg, #ec4899 0%, #db2777 100%);
  color: white;
}

.KlingLipSyncNode-button-active:hover:not(:disabled) {
  background: linear-gradient(135deg, #db2777 0%, #be185d 100%);
}

.KlingLipSyncNode-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 输入框 */
.KlingLipSyncNode-input {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.KlingLipSyncNode-input:focus {
  outline: none;
  border-color: #ec4899;
  background: #fdf2f8;
}

.KlingLipSyncNode-input:disabled {
  background: #f9fafb;
  color: #9ca3af;
  cursor: not-allowed;
}

/* 文本域 */
.KlingLipSyncNode-textarea {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  font-family: inherit;
  resize: vertical;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.KlingLipSyncNode-textarea:focus {
  outline: none;
  border-color: #ec4899;
  background: #fdf2f8;
}

.KlingLipSyncNode-textarea:disabled {
  background: #f9fafb;
  color: #9ca3af;
  cursor: not-allowed;
}

/* 下拉选择框 */
.KlingLipSyncNode-select {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
}

.KlingLipSyncNode-select:focus {
  outline: none;
  border-color: #ec4899;
  background: #fdf2f8;
}

.KlingLipSyncNode-select:disabled {
  background: #f9fafb;
  color: #9ca3af;
  cursor: not-allowed;
}

/* 滑块 */
.KlingLipSyncNode-slider {
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background: #e5e7eb;
  outline: none;
  -webkit-appearance: none;
  margin-bottom: 4px;
}

.KlingLipSyncNode-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ec4899 0%, #db2777 100%);
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(236, 72, 153, 0.3);
  transition: all 0.2s ease;
}

.KlingLipSyncNode-slider::-webkit-slider-thumb:hover {
  transform: scale(1.2);
  box-shadow: 0 4px 8px rgba(236, 72, 153, 0.5);
}

.KlingLipSyncNode-slider::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ec4899 0%, #db2777 100%);
  cursor: pointer;
  border: none;
  box-shadow: 0 2px 4px rgba(236, 72, 153, 0.3);
  transition: all 0.2s ease;
}

.KlingLipSyncNode-slider::-moz-range-thumb:hover {
  transform: scale(1.2);
  box-shadow: 0 4px 8px rgba(236, 72, 153, 0.5);
}

.KlingLipSyncNode-slider:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.KlingLipSyncNode-slider-labels {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: #9ca3af;
}

/* 提示信息 */
.KlingLipSyncNode-hint {
  font-size: 11px;
  line-height: 1.5;
  color: #6b7280;
  background: #f9fafb;
  padding: 10px 12px;
  border-radius: 6px;
  margin-bottom: 12px;
}

.KlingLipSyncNode-hint strong {
  color: #374151;
  font-weight: 600;
}

/* 生成按钮 */
.KlingLipSyncNode-generate {
  width: 100%;
  padding: 12px 20px;
  background: linear-gradient(135deg, #ec4899 0%, #db2777 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(236, 72, 153, 0.3);
}

.KlingLipSyncNode-generate:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(236, 72, 153, 0.4);
  background: linear-gradient(135deg, #db2777 0%, #be185d 100%);
}

.KlingLipSyncNode-generate:active:not(:disabled) {
  transform: translateY(0);
}

.KlingLipSyncNode-generate-disabled {
  background: #d1d5db;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

/* 错误提示 */
.KlingLipSyncNode-error {
  margin-top: 12px;
  padding: 10px 12px;
  background: #fef2f2;
  color: #dc2626;
  border-radius: 6px;
  font-size: 12px;
  border-left: 3px solid #dc2626;
}

/* 复制按钮 */
.KlingLipSyncNode-duplicate-button {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: white;
  color: #6b7280;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s ease;
  opacity: 0;
  pointer-events: none;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.KlingLipSyncNode-container:hover .KlingLipSyncNode-duplicate-button {
  opacity: 1;
  pointer-events: auto;
}

.KlingLipSyncNode-duplicate-button:hover {
  background: #fdf2f8;
  border-color: #ec4899;
  color: #ec4899;
  transform: scale(1.05);
}

.KlingLipSyncNode-duplicate-button:active {
  transform: scale(0.95);
}

/* 连接状态显示 */
.KlingLipSyncNode-status {
  margin-bottom: 12px;
  padding: 12px;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.KlingLipSyncNode-status-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
}

.KlingLipSyncNode-status-item:not(:last-child) {
  border-bottom: 1px dashed #e5e7eb;
  margin-bottom: 6px;
  padding-bottom: 8px;
}

.KlingLipSyncNode-status-label {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
}

.KlingLipSyncNode-status-value {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.KlingLipSyncNode-status-connected {
  color: #10b981;
  background: #d1fae5;
  border: 1px solid #10b981;
}

.KlingLipSyncNode-status-disconnected {
  color: #ef4444;
  background: #fee2e2;
  border: 1px solid #ef4444;
}

`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/KlingLipSyncNode.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd,SAAS;AACT;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA,OAAO;AACP;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,YAAY;AACd;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,iDAAiD;EACjD,+CAA+C;EAC/C,0CAA0C;EAC1C,0BAA0B;EAC1B,yCAAyC;EACzC,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;EACpC,sDAAsD;AACxD;;AAEA;EACE,6DAA6D;EAC7D,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;AAClD;;AAEA,WAAW;AACX;EACE;IACE,UAAU;IACV,6CAA6C;EAC/C;EACA;IACE,UAAU;IACV,4CAA4C;EAC9C;AACF;;AAEA;;EAEE,yEAAyE;AAC3E;;AAEA,mBAAmB;AACnB;EACE,oBAAoB,GAAG,UAAU;EACjC,eAAe,QAAQ,WAAW;EAClC,iBAAiB,MAAM,WAAW;AACpC;;AAEA,eAAe;AACf;EACE,wDAAwD;EACxD,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,eAAe;AACf;EACE,wDAAwD;AAC1D;;AAEA,aAAa;AACb;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA,OAAO;AACP;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,QAAQ;AACR;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,QAAQ;AACR;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,OAAO;AACP;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,eAAe;EACf,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,eAAe;EACf,YAAY;EACZ,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,6DAA6D;AAC/D;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,8BAA8B;AAChC;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B","sourcesContent":["/* 可灵对口型节点样式 */\n\n/* 节点容器 */\n.KlingLipSyncNode-container {\n  position: relative;\n  background: white;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transition: all 0.2s ease;\n  min-width: 320px;\n}\n\n.KlingLipSyncNode-container:hover {\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  border-color: #ec4899;\n}\n\n/* 标题 */\n.KlingLipSyncNode-title {\n  padding: 12px 16px;\n  background: linear-gradient(135deg, #ec4899 0%, #db2777 100%);\n  color: white;\n  font-weight: 600;\n  font-size: 14px;\n  border-radius: 10px 10px 0 0;\n  text-align: center;\n  user-select: none;\n}\n\n/* 内容包装器 */\n.KlingLipSyncNode-wrapper {\n  padding: 16px;\n  width: 320px;\n}\n\n/* Handle 样式 */\n.KlingLipSyncNode-handle {\n  width: 14px;\n  height: 14px;\n  border: 2px solid #ec4899;\n  background: white;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.KlingLipSyncNode-handle:hover {\n  width: 18px;\n  height: 18px;\n  border-width: 3px;\n}\n\n.KlingLipSyncNode-handle-video {\n  border-color: #8b5cf6;\n  background: #8b5cf6;\n}\n\n.KlingLipSyncNode-handle-audio {\n  border-color: #f59e0b;\n  background: #f59e0b;\n}\n\n.KlingLipSyncNode-handle-text {\n  border-color: #667eea;\n  background: #667eea;\n}\n\n.KlingLipSyncNode-handle-output {\n  border-color: #ec4899;\n  background: #ec4899;\n}\n\n/* Handle 标签 */\n.KlingLipSyncNode-handle-label {\n  position: absolute;\n  left: -70px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: linear-gradient(135deg, #ec4899 0%, #db2777 100%);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 12px rgba(236, 72, 153, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(8px);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  letter-spacing: 0.025em;\n  z-index: 100;\n}\n\n.KlingLipSyncNode-handle:hover .KlingLipSyncNode-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(236, 72, 153, 0.35);\n}\n\n.KlingLipSyncNode-handle:hover .KlingLipSyncNode-handle-label::before {\n  content: '';\n  position: absolute;\n  right: -4px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-left: 4px solid #ec4899;\n  border-top: 4px solid transparent;\n  border-bottom: 4px solid transparent;\n  filter: drop-shadow(0 1px 2px rgba(236, 72, 153, 0.2));\n}\n\n.KlingLipSyncNode-handle-video .KlingLipSyncNode-handle-label {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);\n}\n\n.KlingLipSyncNode-handle-video:hover .KlingLipSyncNode-handle-label {\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n.KlingLipSyncNode-handle-video:hover .KlingLipSyncNode-handle-label::before {\n  border-left-color: #667eea;\n  filter: drop-shadow(0 1px 2px rgba(102, 126, 234, 0.2));\n}\n\n/* 节点被选中时，一直显示标签 */\n.react-flow__node.selected .KlingLipSyncNode-handle .KlingLipSyncNode-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(236, 72, 153, 0.35);\n}\n\n.react-flow__node.selected .KlingLipSyncNode-handle-video .KlingLipSyncNode-handle-label {\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n/* 标签出现动画 */\n@keyframes KlingLipSyncNode-labelFadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(-50%) translateX(-10px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(-50%) translateX(-2px);\n  }\n}\n\n.KlingLipSyncNode-handle:hover .KlingLipSyncNode-handle-label,\n.react-flow__node.selected .KlingLipSyncNode-handle .KlingLipSyncNode-handle-label {\n  animation: KlingLipSyncNode-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* 可点击的 Handle 标签 */\n.KlingLipSyncNode-handle-label-clickable {\n  pointer-events: auto;  /* 改为可交互 */\n  cursor: pointer;       /* 显示手型光标 */\n  user-select: none;     /* 禁止文本选择 */\n}\n\n/* 可点击标签的悬停效果 */\n.KlingLipSyncNode-handle-label-clickable:hover {\n  transform: translateY(-50%) translateX(-4px) scale(1.05);\n  box-shadow: 0 8px 24px rgba(236, 72, 153, 0.45);\n}\n\n.KlingLipSyncNode-handle-video .KlingLipSyncNode-handle-label-clickable:hover {\n  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.45);\n}\n\n.KlingLipSyncNode-handle-audio .KlingLipSyncNode-handle-label-clickable:hover {\n  box-shadow: 0 8px 24px rgba(236, 72, 153, 0.45);\n}\n\n/* 可点击标签的按下效果 */\n.KlingLipSyncNode-handle-label-clickable:active {\n  transform: translateY(-50%) translateX(-2px) scale(0.98);\n}\n\n/* 添加点击提示图标 */\n.KlingLipSyncNode-handle-label-clickable::after {\n  content: ' +';\n  font-weight: 700;\n  margin-left: 4px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.KlingLipSyncNode-handle-label-clickable:hover::after {\n  opacity: 1;\n}\n\n/* 字段容器 */\n.KlingLipSyncNode-field {\n  margin-bottom: 16px;\n}\n\n/* 标签 */\n.KlingLipSyncNode-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 8px;\n}\n\n.KlingLipSyncNode-optional {\n  font-weight: 400;\n  color: #9ca3af;\n  font-size: 11px;\n}\n\n/* 按钮组 */\n.KlingLipSyncNode-button-group {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.KlingLipSyncNode-button {\n  padding: 10px 16px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  background: white;\n  color: #6b7280;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.KlingLipSyncNode-button:hover:not(:disabled) {\n  border-color: #ec4899;\n  color: #ec4899;\n  background: #fdf2f8;\n}\n\n.KlingLipSyncNode-button-active {\n  border-color: #ec4899;\n  background: linear-gradient(135deg, #ec4899 0%, #db2777 100%);\n  color: white;\n}\n\n.KlingLipSyncNode-button-active:hover:not(:disabled) {\n  background: linear-gradient(135deg, #db2777 0%, #be185d 100%);\n}\n\n.KlingLipSyncNode-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* 输入框 */\n.KlingLipSyncNode-input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 13px;\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n}\n\n.KlingLipSyncNode-input:focus {\n  outline: none;\n  border-color: #ec4899;\n  background: #fdf2f8;\n}\n\n.KlingLipSyncNode-input:disabled {\n  background: #f9fafb;\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* 文本域 */\n.KlingLipSyncNode-textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 13px;\n  font-family: inherit;\n  resize: vertical;\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n}\n\n.KlingLipSyncNode-textarea:focus {\n  outline: none;\n  border-color: #ec4899;\n  background: #fdf2f8;\n}\n\n.KlingLipSyncNode-textarea:disabled {\n  background: #f9fafb;\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* 下拉选择框 */\n.KlingLipSyncNode-select {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 13px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.KlingLipSyncNode-select:focus {\n  outline: none;\n  border-color: #ec4899;\n  background: #fdf2f8;\n}\n\n.KlingLipSyncNode-select:disabled {\n  background: #f9fafb;\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* 滑块 */\n.KlingLipSyncNode-slider {\n  width: 100%;\n  height: 6px;\n  border-radius: 3px;\n  background: #e5e7eb;\n  outline: none;\n  -webkit-appearance: none;\n  margin-bottom: 4px;\n}\n\n.KlingLipSyncNode-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #ec4899 0%, #db2777 100%);\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(236, 72, 153, 0.3);\n  transition: all 0.2s ease;\n}\n\n.KlingLipSyncNode-slider::-webkit-slider-thumb:hover {\n  transform: scale(1.2);\n  box-shadow: 0 4px 8px rgba(236, 72, 153, 0.5);\n}\n\n.KlingLipSyncNode-slider::-moz-range-thumb {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #ec4899 0%, #db2777 100%);\n  cursor: pointer;\n  border: none;\n  box-shadow: 0 2px 4px rgba(236, 72, 153, 0.3);\n  transition: all 0.2s ease;\n}\n\n.KlingLipSyncNode-slider::-moz-range-thumb:hover {\n  transform: scale(1.2);\n  box-shadow: 0 4px 8px rgba(236, 72, 153, 0.5);\n}\n\n.KlingLipSyncNode-slider:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.KlingLipSyncNode-slider-labels {\n  display: flex;\n  justify-content: space-between;\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n/* 提示信息 */\n.KlingLipSyncNode-hint {\n  font-size: 11px;\n  line-height: 1.5;\n  color: #6b7280;\n  background: #f9fafb;\n  padding: 10px 12px;\n  border-radius: 6px;\n  margin-bottom: 12px;\n}\n\n.KlingLipSyncNode-hint strong {\n  color: #374151;\n  font-weight: 600;\n}\n\n/* 生成按钮 */\n.KlingLipSyncNode-generate {\n  width: 100%;\n  padding: 12px 20px;\n  background: linear-gradient(135deg, #ec4899 0%, #db2777 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(236, 72, 153, 0.3);\n}\n\n.KlingLipSyncNode-generate:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(236, 72, 153, 0.4);\n  background: linear-gradient(135deg, #db2777 0%, #be185d 100%);\n}\n\n.KlingLipSyncNode-generate:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.KlingLipSyncNode-generate-disabled {\n  background: #d1d5db;\n  cursor: not-allowed;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* 错误提示 */\n.KlingLipSyncNode-error {\n  margin-top: 12px;\n  padding: 10px 12px;\n  background: #fef2f2;\n  color: #dc2626;\n  border-radius: 6px;\n  font-size: 12px;\n  border-left: 3px solid #dc2626;\n}\n\n/* 复制按钮 */\n.KlingLipSyncNode-duplicate-button {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 28px;\n  height: 28px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: white;\n  color: #6b7280;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  opacity: 0;\n  pointer-events: none;\n  z-index: 10;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.KlingLipSyncNode-container:hover .KlingLipSyncNode-duplicate-button {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.KlingLipSyncNode-duplicate-button:hover {\n  background: #fdf2f8;\n  border-color: #ec4899;\n  color: #ec4899;\n  transform: scale(1.05);\n}\n\n.KlingLipSyncNode-duplicate-button:active {\n  transform: scale(0.95);\n}\n\n/* 连接状态显示 */\n.KlingLipSyncNode-status {\n  margin-bottom: 12px;\n  padding: 12px;\n  background: #f9fafb;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n}\n\n.KlingLipSyncNode-status-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 0;\n}\n\n.KlingLipSyncNode-status-item:not(:last-child) {\n  border-bottom: 1px dashed #e5e7eb;\n  margin-bottom: 6px;\n  padding-bottom: 8px;\n}\n\n.KlingLipSyncNode-status-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n}\n\n.KlingLipSyncNode-status-value {\n  font-size: 12px;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.KlingLipSyncNode-status-connected {\n  color: #10b981;\n  background: #d1fae5;\n  border: 1px solid #10b981;\n}\n\n.KlingLipSyncNode-status-disconnected {\n  color: #ef4444;\n  background: #fee2e2;\n  border: 1px solid #ef4444;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
